import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from '@chakra-ui/accordion'
import { Box, Flex, Text } from '@chakra-ui/layout'
import { Divider, FormControl, FormLabel, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useToast } from '@chakra-ui/react'
import { List } from 'immutable'

import { useEffect, useState } from 'react'
import { FaBrain, FaChevronDown, FaChevronRight, FaEye, FaFileDownload, FaFileUpload, FaFilter, FaPencilAlt, FaPlus, FaTrash } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../components/ElementoTooltipCmp'
import { ModalDelete } from '../../../components/ModalDelete'
import { Paginador } from '../../../components/Paginador'
import { SearchCmp } from '../../../components/SearchCmp'
import { SelectCmp } from '../../../components/SelectCmp'
import { WhiteContainer } from '../../../components/WhiteContainer'
import { DescricaoCargo, iNomeId } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { formatNumberBR } from '../../../Utils/Helper'
import { Body } from '../../Layouts/Body'
import { CargoContent } from './components/CargoContent'
import { ModalCadastroEmMassa } from './components/ModalCadastroEmMassa'
import { iDescritivoInput, ModalCreate } from './components/ModalCreate'
import { ModalIA } from './components/ModalIA'
import { Sidebar } from './components/Sidebar'
import { useVisaoGestor } from '../utils/visaoGestor'

export interface iCargosPendentes {
  colaboradores?: number
  id: string
  nome: string
  temCargo?: boolean
}

export const DescritivoCargos: React.FC = () => {
  const nav = useNavigate()
  const visaoGestor = useVisaoGestor()
  const [Texto, setTexto] = useState('')
  const [ModalIsOpen, setModalIsOpen] = useState(false)
  const [ModalIAIsOpen, setModalIAIsOpen] = useState(false)
  const [Cargos, setCargos] = useState<DescricaoCargo[]>()
  const [ModelEdit, setModelEdit] = useState<DescricaoCargo>()
  const [IsLoading, setIsLoading] = useState(false)
  const [DeleteId, setDeleteId] = useState<string>()
  const [QtdCargos, setQtdCargos] = useState(0)
  const [Pagina, setPagina] = useState(0)
  const [Tamanho, setTamanho] = useState(25)
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [CsvItens, setCsvItens] = useState(false)
  const [ModalCadastroIsOpen, setModalCadastroIsOpen] = useState(false)
  const toast = useToast()
  const [Departamentos, setDepartamentos] = useState<iNomeId[]>([])
  const [DepartamentoFiltro, setDepartamentoFiltro] = useState('')
  const [CargosPendentes, setCargosPendentes] = useState<List<iCargosPendentes>>(List())
  const [ModalListaPendecia, setModalListaPendecia] = useState(false)
  const [prefillFuncao, setPrefillFuncao] = useState<iCargosPendentes | null>(null)
  const [qtdColaboradores, setQtdColaboradores] = useState<number>(0)

  function onDeleteCargo(cargoId: string): void {
    setIsLoading(true)

    appApi.delete(`api/CargosESalarios/${cargoId}`)
      .then((res) => {
        toast({
          title: 'Cargo excluído com sucesso',
          position: 'top',
          duration: 4000,
          status: 'success'
        })
        GetDescritivos()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
        setDeleteId(undefined)
      })
  }

  function getDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => {
        setDepartamentos(res.data)
      })
      .catch(err => console.log(err))
  }

  function PostDescritivo(newCargo: iDescritivoInput): void {
    setIsLoading(true)

    appApi.post('api/CargosESalarios', { ...newCargo })
      .then((res) => {
        toast({
          title: 'Cargo criado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        nav(`${res.data}`)
      })
      .catch(err => {
        console.log(err)
        toast({
          title: 'Não foi possível criar o cargo',
          duration: 4000,
          status: 'error',
          position: 'top'
        })
      })
      .finally(() => {
        setIsLoading(false)
        setModelEdit(undefined)
      })
  }

  function PutDescritivo(newCargo: iDescritivoInput): void {
    setIsLoading(true)

    appApi.put(`api/CargosESalarios/${ModelEdit?.id}`, { ...newCargo })
      .then((res) => {
        toast({
          title: 'Cargo atualizado com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        setModelEdit(undefined)
        setModalIsOpen(false)
        GetDescritivos()
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false)
      })
  }

  function GetDescritivos(isSearch?: boolean): void {
    setIsLoading(true)

    appApi.get(`api/CargosESalarios?pagina=${Pagina}&quantidade=${Tamanho}&departamentoId=${DepartamentoFiltro}&buscar=${Texto}`)
      .then((res) => {
        if (res.data.length === 0 && Pagina > 0) {
          setPagina(0)
        } else {
          setCargos(res.data)
        }

        if (isSearch) {
          GetDescritivosQuantidade()
        }
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function GetDescritivosQuantidade(): void {
    setIsLoading(true)

    appApi.get(`api/CargosESalarios/Quantidade?departamentoId=${DepartamentoFiltro}&buscar=${Texto}`)
      .then((res) => {
        setQtdCargos(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function getNiveisTexto(cargo: DescricaoCargo): string {
    if (Object.entries(cargo.niveis).length <= 0) {
      if (cargo.tipoNivel === 'Júnior/Pleno/Sênior') {
        return 'Júnior / Pleno / Sênior'
      }
      if (cargo.tipoNivel === 'I, II e III') {
        return 'Nível I / Nível II / Nível III'
      }
      if (cargo.tipoNivel === 'I, II, III, IV e V') {
        return 'Nível I / Nível II / Nível III / Nível IV / Nível V'
      }
      return cargo.tipoNivel
    }
    return Object.keys(cargo.niveis).map(nivel => nivel.includes('_') ? nivel.replaceAll('_', ' ') : nivel).join(' / ')
  }

  function acaoModal(): void {
    setModalIsOpen(true)
    getFuncoesEmPendencia()
  }

  function getFuncoesEmPendencia(): void {
    appApi.get<iCargosPendentes[]>('/Cargo/pendentes')
      .then(res => {
        setCargosPendentes(List(res.data ?? []))
      })
      .catch(err => console.log(err))
  }

  function GetQuantidadeColaboradores(id: string): void {
    appApi.get<number>(`cargo/quantidadeColaboradores/${id}`)
      .then((res) => {
        setQtdColaboradores(res.data)
      })
      .catch(err => console.log(err))
  }

  function acaoExcluir(id: string, funcaoId?: string): void {
    setDeleteId(id)
    if (funcaoId) {
      GetQuantidadeColaboradores(funcaoId)
    }
  }

  useEffect(() => {
    GetDescritivos(true)
    getDepartamentos()
    if (!visaoGestor) getFuncoesEmPendencia()
  }, [])

  useEffect(() => {
    if (Cargos) {
      GetDescritivos()
    }
  }, [Pagina, Tamanho])

  return (
    <Flex justifyContent={'center'} alignItems={'self-start'} pos={'relative'} gap={'2rem'} margin={'0 auto'} pr={'2rem'}>
      <ModalCreate
        isOpen={ModalIsOpen}
        onClose={() => { setModalIsOpen(false); setModelEdit(undefined); setPrefillFuncao(null) }}
        onCreate={(input, isEdit) => { isEdit ? PutDescritivo(input) : PostDescritivo(input) }}
        modelEdit={ModelEdit}
        onReloadDeps={getDepartamentos}
        departamentos={Departamentos}
        CargosPendentes={CargosPendentes}
        getFuncoesEmPendencia={getFuncoesEmPendencia}
        prefillFuncao={prefillFuncao}
      />
      <ModalIA
        isOpen={ModalIAIsOpen}
        onClose={() => setModalIAIsOpen(false)}
      />
      <ModalCadastroEmMassa
        isOpen={ModalCadastroIsOpen}
        onRequestClose={() => setModalCadastroIsOpen(false)}
        reload={() => { GetDescritivos() }}
        isItens={CsvItens}
      />
      <Modal
        isOpen={ModalListaPendecia}
        onClose={() => setModalListaPendecia(false)}
        size="lg"
        isCentered
        scrollBehavior="inside"

      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Cargos sem descrição</ModalHeader>
          <ModalCloseButton bgColor={'red.400'} />

          <ModalBody>
            {CargosPendentes.size === 0
              ? (
              <Text color="gray.500">Nenhum cargo pendente.</Text>
                )
              : (
              <Flex direction="column" gap="10px">
                {CargosPendentes.map((c) => (
                  <Box
                    key={c?.id}
                    p="12px"
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="8px"
                    _hover={{ bg: 'gray.50' }}
                  >
                    <Flex justify="space-between" align="start" gap="12px">
                      <Box>
                        <Text fontWeight="700">{c?.nome}</Text>
                        <Text fontSize="12px" color="gray.600">
                          {c?.temCargo ? ' • já tem cargo' : ''}
                        </Text>
                      </Box>

                      <ButtonCmp
                        VarColor="Green2"
                        onClick={() => {
                          setPrefillFuncao(c as iCargosPendentes)
                          setModalListaPendecia(false)
                          setModelEdit(undefined)
                          setModalIsOpen(true)
                        }}
                      >
                        Criar descrição
                      </ButtonCmp>
                    </Flex>
                  </Box>
                )) as any}
              </Flex>
                )}
          </ModalBody>
          <Divider />
          <ModalFooter>
            <ButtonCmp VarColor="c6" onClick={() => setModalListaPendecia(false)}>
              Fechar
            </ButtonCmp>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {DeleteId && <ModalDelete
        isOpen
        message='Tem certeza que deseja excluir esse cargo?'
        onConfirm={() => onDeleteCargo(DeleteId)}
        onRequestClose={() => setDeleteId(undefined)}
        center
        qntdeColaboradoresNaFuncao={qtdColaboradores}
      />}
      <Flex
        position="sticky"
        top="0"
        left="0"
        direction="column"
        bg="white"
        transition="width 0.3s"
        width={isCollapsed ? '60px' : '220px'}
        height="100vh">
        <Sidebar onCollapse={setIsCollapsed} isCollapsed={isCollapsed} selecionado={'Cargos'}/>
      </Flex>
      <Body isLoading={IsLoading} style={{ width: '100%' }} width={'100%'}>
        <Flex flexDir={'column'} gap={'1rem'}>
          <Flex justifyContent={'space-between'}>
            <Flex flexDir={'column'} gap={'.75rem'}>
              <h1>Gerenciamento de cargos</h1>
              <ButtonCmp VarColor='c6' w={'6rem'} onClick={() => nav(-1)}>Voltar</ButtonCmp>
            </Flex>
            {!visaoGestor && (
              <Flex gap={'.75rem'}>
                <Flex flexDir={'column'} gap='.75rem'>
                  <ButtonCmp OutlineColor='Roxo' leftIcon={<FaFileUpload/>} onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/CargosESalarios/CsvItens?token=${localStorage.getItem('token')}` }}>Exportar dados dos itens</ButtonCmp>
                  <ButtonCmp OutlineColor='Roxo' leftIcon={<FaFileDownload/>} onClick={() => { setModalCadastroIsOpen(true); setCsvItens(true) }}>Importar dados dos itens</ButtonCmp>
                </Flex>
                <Flex flexDir={'column'} gap='.75rem'>
                  <ButtonCmp OutlineColor='Rosa' leftIcon={<FaFileUpload/>} onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/CargosESalarios/CSV?token=${localStorage.getItem('token')}` }}>Exportar dados gerais</ButtonCmp>
                  <ButtonCmp OutlineColor='Azul' leftIcon={<FaFileDownload/>} onClick={() => { setModalCadastroIsOpen(true); setCsvItens(false) }}>Importar dados gerais</ButtonCmp>
                </Flex>
              </Flex>
            )}
          </Flex>
          <Flex justifyContent={'space-between'} mt={'1rem'} gap={'1rem'} alignItems={'end'}>
            {!visaoGestor && (
            <Flex gap={'1rem'}>
              <ButtonCmp VarColor='Green2' leftIcon={<FaPlus/>} onClick={() => acaoModal()}>Criar novo cargo</ButtonCmp>
              <ButtonCmp OutlineColor='Roxo' leftIcon={<FaBrain/>} onClick={() => setModalIAIsOpen(true)}>Gerar informações por IA</ButtonCmp>
              <Box position={'relative'} display={'inline-block'}>
                <ButtonCmp VarColor='Blue2' onClick={() => setModalListaPendecia(true)}>Cargos sem descrição</ButtonCmp>
                {CargosPendentes.size > 0 && (
                <Box
                  position="absolute"
                  top="-8px"
                  right="-8px"
                  minW="18px"
                  h="18px"
                  px="4px"
                  borderRadius="full"
                  bg="red.500"
                  color="white"
                  fontSize="11px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  border="2px solid"
                  borderColor="white"
                >
                  {CargosPendentes.size}
                </Box>
                )}
              </Box>
            </Flex>
            )}
            <Flex gap={'1rem'} alignItems={'end'} ml={'auto'}>
              <SelectCmp OnChange={setDepartamentoFiltro} w={'14rem'} value={DepartamentoFiltro} title='Filtrar por área'>
                <option value={''}>Nenhum</option>
                {Departamentos.map(e => {
                  return <option value={e.id}>{e.nome}</option>
                })}
              </SelectCmp>
              <FormControl width={'14rem'}>
                <FormLabel color={'var(--Gray1)'} fontSize={'14px'} mb={'.25rem'}>Buscar por nome</FormLabel>
                <SearchCmp
                  EnterAction={() => GetDescritivos(true)}
                  OnChange={setTexto}
                  placeholder={'Nome do cargo...'}
                  width={'14rem'}
                />
              </FormControl>
              <ButtonCmp VarColor='Green2' w={'5.325rem'} leftIcon={<FaFilter/>} onClick={() => GetDescritivos(true)}>Filtrar</ButtonCmp>
            </Flex>
          </Flex>
        </Flex>
        <Paginador
          next={setPagina}
          paginaAtual={Pagina}
          prev={setPagina}
          qtdElementos={QtdCargos}
          setTamanho={setTamanho}
          tamanho={Tamanho}
          hideTop
        >
          <Flex flexDir={'column'} gap={'1rem'} my={'1rem'}>
            {visaoGestor && Cargos?.length === 0 && (
              <Text color="var(--Gray3)">Nenhum cargo subordinado ao seu cargo.</Text>
            )}
            {Cargos?.map(cargo => {
              return <WhiteContainer>
                <Accordion allowToggle>
                  <AccordionItem key={cargo.id} border="none">
                    {({ isExpanded }) => (
                      <>
                        <Flex
                          borderBottom={isExpanded ? '1px solid var(--Azul)' : 'none'}
                          pb={isExpanded ? '1rem' : 'none'}
                          mb={isExpanded ? '1rem' : 'none'}
                          _hover={{ bg: 'gray.50' }}
                          transition={'.3s'}>
                          <AccordionButton bg="white" _focus={{ boxShadow: 'none !important' }}>
                            <Flex flex="1" direction="column" gap={'.25rem'} alignItems="self-start">
                              <Flex gap=".5rem" alignItems="center">
                                <Box
                                  as={isExpanded ? FaChevronDown : FaChevronRight}
                                  color="var(--Green2)"
                                  size="20px"
                                  transition="transform 0.2s ease"
                                />
                                <Text color="#000" fontSize="22px" fontWeight="bold">
                                  {cargo.nomeCargo}
                                </Text>
                              </Flex>
                              <Text fontSize="14px" color="var(--Gray3)">
                                {getNiveisTexto(cargo)}
                              </Text>
                              <Text fontSize="14px" color="var(--Gray3)">
                                CBO: {cargo.cbo}
                              </Text>
                              {Object.entries(cargo.niveis)?.length > 0 && (() => {
                                const niveis = Object.entries(cargo.niveis)
                                const primeiroNivel = niveis[0][1]
                                const ultimoNivel = niveis[niveis.length - 1][1]

                                return (
                                  <Text fontSize="14px" color="var(--Gray3)">
                                    R${formatNumberBR(primeiroNivel.primeiroQuartil)} - R${formatNumberBR(ultimoNivel.terceiroQuartil)}
                                  </Text>
                                )
                              })()}
                            </Flex>
                          </AccordionButton>
                          <Flex flexDir={'column'} gap={'.5rem'}>
                            <ElementoTooltipCmp label='Visualizar detalhes' bg={'var(--Green2)'}>
                              <ButtonCmp VarColor='Green2' onClick={() => nav(`${cargo.id}`)}><FaEye/></ButtonCmp>
                            </ElementoTooltipCmp>
                            {!visaoGestor && (
                              <>
                                <ElementoTooltipCmp label='Editar' bg={'var(--Rosa)'}>
                                  <ButtonCmp OutlineColor='Rosa' onClick={() => { setModelEdit(cargo); setModalIsOpen(true); setIsCollapsed(true) }}><FaPencilAlt/></ButtonCmp>
                                </ElementoTooltipCmp>
                                <ElementoTooltipCmp label='Excluir' bg={'var(--Red)'}>
                                  <ButtonCmp OutlineColor='Red' onClick={() => acaoExcluir(cargo.id, cargo.funcaoId)}><FaTrash/></ButtonCmp>
                                </ElementoTooltipCmp>
                              </>
                            )}
                          </Flex>
                        </Flex>
                        <AccordionPanel border={'2px solid var(--c6)'} bg={'var(--c2)'} d={'flex'} flexDir={'column'} gap={'1rem'}>
                          <CargoContent cargo={cargo}/>
                        </AccordionPanel>
                      </>
                    )}
                  </AccordionItem>
                </Accordion>
              </WhiteContainer>
            })}
          </Flex>
        </Paginador>
      </Body>
    </Flex>
  )
}
